"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProspectsHttpService = void 0;
const list_prospects_1 = require("../../types/referrals/list-prospects");
const http_service_1 = require("../http.service");
/**
 * The staff-facing prospect mirror. Airtable owns these rows and the hourly
 * sync writes them, so there is no endpoint to edit one — only
 * {@link ProspectsHttpService.removeById}, which discards a local row whose
 * Airtable record is already gone.
 */
class ProspectsHttpService extends http_service_1.HttpService {
    constructor(apiUrl) {
        super(`${apiUrl}/prospects`);
    }
    /**
     * Lists prospects, most recently contacted first.
     *
     * @param params - Paging, plus optional free-text and status filters.
     * @returns The requested page and the total number of matches.
     */
    getList(params) {
        return this.fetch(this.getApiUrlOf('', {
            page: String(params.page),
            per_page: String(params.per_page),
            ...(params.search ? { search: params.search } : {}),
            ...(params.status ? { status: params.status } : {}),
        }), { method: 'GET', schema: list_prospects_1.listProspectsApiResponseSchema }).then(({ data }) => data);
    }
    /**
     * Removes a mirror row the sync has flagged as missing from Airtable.
     *
     * @param prospectId - The prospect to remove.
     * @returns Nothing; the API answers 204.
     */
    removeById(prospectId) {
        return this.fetch(this.getApiUrlOf(prospectId), {
            method: 'DELETE',
        }).then(() => undefined);
    }
}
exports.ProspectsHttpService = ProspectsHttpService;
